var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBtnLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.138 1.815A3 3 0 0 1 14 4.688v14.624a3 3 0 0 1-3.862 2.873l-6-1.8A3 3 0 0 1 2 17.512V6.488a3 3 0 0 1 2.138-2.873l6-1.8ZM15 4a1 1 0 0 1 1-1h3a3 3 0 0 1 3 3v1a1 1 0 0 1-2 0V6a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1Zm6 12a1 1 0 0 1 1 1v1a3 3 0 0 1-3 3h-3a1 1 0 0 1 0-2h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1ZM9 11a1 1 0 0 0 0 2h.001a1 1 0 0 0 0-2H9Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m16 12 2 2m3-2h-5 5Zm-5 0 2-2-2 2Z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgBtnLogin as ReactComponent };
export default __webpack_public_path__ + "static/media/btn-login.7015cbc6.svg";